import { Navigate, Route, Routes } from "react-router-dom";
import { LoginPage } from "@/pages/LoginPage";
import { ApprovalPage } from "@/pages/ApprovalPage";
import { MyApprovalsPage } from "@/pages/MyApprovalsPage";
import { DashboardPage } from "@/pages/DashboardPage";
import { UsersPage } from "@/pages/UsersPage";
import { ProfilePage } from "@/pages/ProfilePage";
import { ActivityPage } from "@/pages/ActivityPage";
import { CreateBillPage } from "@/pages/CreateBillPage";
import { SupportedVendorsPage } from "@/pages/SupportedVendorsPage";
import { LightreachImportPage, LightreachImportsPage } from "@/pages/LightreachImportPage";
import { TeslaRemitPage, TeslaRemitsPage } from "@/pages/TeslaRemitPage";
import { PaymentSyncPage } from "@/pages/PaymentSyncPage";
import { CollectionsPage } from "@/pages/CollectionsPage";
import { NetsuiteMapPage } from "@/pages/NetsuiteMapPage";
import { CloseReviewPage } from "@/pages/CloseReviewPage";
import { CloseReviewPeriodPage } from "@/pages/closeReview/PeriodPage";
import { CloseReviewCheckPage } from "@/pages/closeReview/CheckPage";
import { ProtectedRoute } from "@/components/ProtectedRoute";

export function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      {/* Bill approval from the emailed link: public, the approver signs in on the page. */}
      <Route path="/approvals" element={<MyApprovalsPage />} />
      <Route path="/approvals/:token" element={<ApprovalPage />} />
      <Route path="/" element={<ProtectedRoute><DashboardPage /></ProtectedRoute>} />
      {/* Same page; the :id opens that decision's detail over the (filtered) list. */}
      <Route path="/decisions/:id" element={<ProtectedRoute><DashboardPage /></ProtectedRoute>} />
      {/* NetSuite bill creation: OCR'd PDF beside an editable bill draft. */}
      <Route path="/bills/:id" element={<ProtectedRoute><CreateBillPage /></ProtectedRoute>} />
      {/* Lightreach AR import: upload the payout export, dry run, post to NetSuite. */}
      <Route path="/lightreach" element={<ProtectedRoute><LightreachImportsPage /></ProtectedRoute>} />
      <Route path="/lightreach/:id" element={<ProtectedRoute><LightreachImportPage /></ProtectedRoute>} />
      {/* Tesla RMA remits: upload a portal remittance export, dry run, post to NetSuite. */}
      <Route path="/tesla" element={<ProtectedRoute><TeslaRemitsPage /></ProtectedRoute>} />
      <Route path="/tesla/:id" element={<ProtectedRoute><TeslaRemitPage /></ProtectedRoute>} />
      {/* Payment sync: NetSuite payments check off Sunrise payment tasks (AR posters). */}
      <Route path="/payment-sync" element={<ProtectedRoute><PaymentSyncPage /></ProtectedRoute>} />
      <Route path="/payment-sync/:id" element={<ProtectedRoute><PaymentSyncPage /></ProtectedRoute>} />
      {/* Collections (moved from the Resource Dashboard): cash payments customers still owe. */}
      <Route path="/collections" element={<ProtectedRoute><CollectionsPage /></ProtectedRoute>} />
      {/* NetSuite Transaction Map (config/netsuite_map.yml) with staff comments. */}
      <Route path="/netsuite-map" element={<ProtectedRoute><NetsuiteMapPage /></ProtectedRoute>} />
      {/* Close Review: month-end checks, P&L, Balance Sheet and Statistical Journals from fsp-bi-hub. */}
      <Route path="/close-review" element={<ProtectedRoute><CloseReviewPage /></ProtectedRoute>} />
      <Route path="/close-review/:month" element={<ProtectedRoute><CloseReviewPeriodPage /></ProtectedRoute>} />
      <Route path="/close-review/:month/:key" element={<ProtectedRoute><CloseReviewCheckPage /></ProtectedRoute>} />
      <Route path="/settings/vendors" element={<ProtectedRoute><SupportedVendorsPage /></ProtectedRoute>} />
      <Route path="/settings/users" element={<ProtectedRoute><UsersPage /></ProtectedRoute>} />
      {/* Private per-user activity report (super admins only, like Users). */}
      <Route path="/settings/activity" element={<ProtectedRoute><ActivityPage /></ProtectedRoute>} />
      <Route path="/profile" element={<ProtectedRoute><ProfilePage /></ProtectedRoute>} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
